import breakpoints from '@/constants/breakpoints';
import React from 'react';
import getImageUrl, {IMGIX} from '@/utils/images';
import Imgix, {Background} from 'react-imgix';
import styled from 'styled-components';
import useSale from '@/hooks/useSale'; // temporarily disable hero sale
import { useSelector } from 'react-redux';



const images = {
  sale: {
    mobile: 'sales/cherry-blossom/TI-F%26F-Mobile-750x750.jpg',
    desktop: 'sales/cherry-blossom/TI-FF-Desktop-3200x1300.jpg',
  },
  tradeSale: {
    mobile: 'sales/cherry-blossom/TI-F%26F-Mobile-750x750.jpg',
    desktop: 'sales/cherry-blossom/TI-FF-Desktop-3200x1300.jpg',
  },
  // default: {
  //   mobile: 'homepage/rebrand/home-hero-mob-q4-2023.jpg',
  //   desktop: 'homepage/rebrand/TI_Print_Web_Hero_v31.jpg'
  // }
  default: {
    mobile: 'homepage/rebrand/Hero-Bed-2025-mobile.jpg',
    desktop: 'homepage/rebrand/Hero-Bed-2025-desktop.jpg'
  }
};

function Hero() {

  const user = useSelector(state => state.Auth.user);
  const isTrade = [2].includes(parseInt(user.role_id));
  // const isTrade = true;



  const url = `/c/bedroom-furniture/beds`;
  const titleText = 'Your Happy Place.';
  const buttonText = 'Shop Now';
  const {isSale} = useSale();
  const CTA_URL = isSale ? '/collections/bestsellers' : null;

  const desktopImageProps = {
    src: getImage('desktop', isSale, isTrade),
    srcSet: `
            ${getImage('desktop', isSale, isTrade)}@3x.jpg 3x,
            ${getImage('desktop', isSale, isTrade)}@2x.jpg 2x,
            ${getImage('desktop', isSale, isTrade)}@1x.jpg 1x,
          `,
    htmlAttributes: {alt: 'Hero'}
  };

  return (
    <Container>
      <a className="phone-only" href={CTA_URL}>
        {isSale ? (
          <div className="sale-image">
            <img
              alt={isSale ? 'Sale Hero' : 'Hero'}
              src={getImage('mobile', true, isTrade)}
            />
          </div>
        ) : (
          <Background
            className="mobile-bg"
            imgixParams={{w: 768, crop: 'top', auto: 'compress,format'}}
            src={getImage('mobile', false)}
            sizes="100vw"
            htmlAttributes={{
              alt: 'background image'
            }}
          >
            <Title>{titleText}</Title>
            <Copy>Create a sanctuary that sparks joy.</Copy>
            <VerticalSpace space={24.6}/>
            <Cta href={url}>{buttonText}</Cta>
          </Background>
        )}
      </a>
      <a className="tablet-or-higher-only desktop-hero" href={CTA_URL}>
        {isSale ? (
          <Imgix
            className="desktop-image"
            imgixParams={{auto: 'compress,format'}}
            {...desktopImageProps}
          />
        ) : (
          <>
            <Background
              className="desktop-bg"
              imgixParams={{
                auto: 'compress,format',
                fit: 'crop',
                crop: 'focalpoint',
                'fp-y': .62
              }}
              {...desktopImageProps}
            />
            <div className="content">
              <div className="inner-content">
                <Title>{titleText}</Title>
                <Copy>Create a sanctuary that sparks joy.</Copy>
                <VerticalSpace space={21}/>
                <Cta href={url}>{buttonText}</Cta>
              </div>
            </div>
          </>
        )}
      </a>
    </Container>
  );
}

const Container = styled.div`
  max-width: 100%;
  padding-bottom: 35px;
  @media (min-width: ${breakpoints['tablet']}px) {
    padding-bottom: 38px;
  }
  @media (min-width: ${breakpoints['desktop']}px) {
    padding-bottom: 69px;
  }

  .mobile-bg {
    position: relative;
    display: flex;
    flex: 1;
    height: 375px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-position: bottom;
  }

  .desktop-hero {
    display: flex;
    position: relative;
  }

  .desktop-bg {
    height: 650px;
    flex: 1;
    background-position: top;
  }

  .desktop-image {
    width: 100%;
  }

  .content {
    position: absolute;
    left: 50%;
    top: 40%;
    top: 56%;
    transform: translate(-50%, -50%);
    width: 100%;
    margin: 0 auto;

    .inner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      // width: 630px;
      max-width: 920px;
      width: 100%;
      margin: 0 auto;

      @media (min-width: ${breakpoints['desktop']}px) {
        gap: 7px;
      }

      @media (min-width: ${breakpoints['large-desktop']}px) {
        gap: 12px;
      }

      @media (min-width: ${breakpoints['xlarge-desktop']}px) {
        // margin-top: -20%;
      }
    }
  }

  .phone-only {
    display: flex;
  }

  .tablet-or-higher-only {
    display: none;
  }

  .phone-only:hover {
    text-decoration: none;
    color: inherit;
  }

  width: 100%;
  @media (min-width: ${breakpoints['tablet']}px) {
    .phone-only {
      display: none;
    }

    .tablet-or-higher-only {
      display: flex;
    }
  }

  .sale-image {
    img {
      width: 100%;
    }
  }
`;

const Title = styled.h1`
  font-family: ${({theme}) => theme.fonts.secondary.family};
  letter-spacing: ${({theme}) =>
  theme.old ? '-2.5px' : theme.fonts.secondary.letterSpacing};
  font-weight: 300;
  text-align: center;
  font-size: 50px;
  line-height: 55px;
  color: #fff;
  max-width: 320px;
  text-shadow: 0px 0px 23px #000000;

  @media (min-width: 768px) {
    font-size: 60px;
    letter-spacing: -2.4px;
    max-width: unset;
  }

  @media (min-width: 1024px) {
    font-size: 80px;
    letter-spacing: -3.2px;
  }
`;

const Copy = styled.p`
  font-family: 'Graphik';
  letter-spacing: .015em;
  text-align: center;
  font-size: 16px;
  color: #fff;
  max-width: 520px;
  text-shadow: 0px 0px 23px #000000;
  margin-top: 10px;
  font-weight: 300;

  @media (min-width: 768px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 26px;
  }
`;


const Cta = styled.a`
  font-size: 16px;
  width: 130px;
  border-radius: 80px;
  padding: 11.3px 21.5px 11.3px 21.5px;
  // color: ${({theme}) => theme.buttons.secondary.color};
  color: #fff;
  text-align: center;
  cursor: pointer;
  // background-color: ${({bgColor, theme}) => bgColor || theme.buttons.secondary.backgroundColor};
  background-color: #666025;

  &:hover {
    // color: ${({theme}) => theme.buttons.secondary.hover.color};
    color: #fff;
    text-decoration: none;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 18px;
    width: 184px;
    height: 52px;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    font-size: 22px;
    width: 207px;
    height: 58px;
  }
`;

const VerticalSpace = styled.div`
  margin-bottom: ${props => props.space + 'px' || '10px'};
`;

// function getImage(index, isSale) {
//   const version = isSale ? 'sale' : 'default';
//
//   return getImageUrl(images[version][index], IMGIX);
// }

function getImage(index, isSale, isTrade) {
  const version = isSale ? (isTrade ? 'tradeSale' : 'sale') : 'default';

  return getImageUrl(images[version][index], IMGIX);
}

export default Hero;
